module.exports = __webpack_public_path__ + "img/update-selected-sites.5a132c38.svg";